import { FieldHookConfig, useField } from 'formik'
import { FormControlLabel, Switch, SwitchProps } from '@mui/material'

interface Props extends Omit<SwitchProps, 'variant'> {
  label?: string
}

export default function InputFormikSwitch(
  props: Props & FieldHookConfig<string>,
) {
  const [field] = useField(props)

  const { label } = props

  return (
    <FormControlLabel
      control={
        <Switch
          checked={Boolean(field.value)}
          {...field}
          value={field.value ? field.value : ''}
          color="primary"
        />
      }
      label={label || ''}
    />
  )
}
